var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 22C20.6569 22 22 20.6569 22 19C22 17.3431 20.6569 16 19 16C17.3431 16 16 17.3431 16 19C16 20.6569 17.3431 22 19 22Z",
    stroke: "#32174E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19.8799V18.1199C9 17.0799 9.85 16.2199 10.9 16.2199C12.71 16.2199 13.45 14.9399 12.54 13.3699C12.02 12.4699 12.33 11.2999 13.24 10.7799L14.97 9.78994C15.76 9.31994 16.78 9.59994 17.25 10.3899L17.36 10.5799C18.26 12.1499 19.74 12.1499 20.65 10.5799L20.76 10.3899C21.23 9.59994 22.25 9.31994 23.04 9.78994L24.77 10.7799C25.68 11.2999 25.99 12.4699 25.47 13.3699C24.56 14.9399 25.3 16.2199 27.11 16.2199C28.15 16.2199 29.01 17.0699 29.01 18.1199V19.8799C29.01 20.9199 28.16 21.7799 27.11 21.7799C25.3 21.7799 24.56 23.0599 25.47 24.6299C25.99 25.5399 25.68 26.6999 24.77 27.2199L23.04 28.2099C22.25 28.6799 21.23 28.3999 20.76 27.6099L20.65 27.4199C19.75 25.8499 18.27 25.8499 17.36 27.4199L17.25 27.6099C16.78 28.3999 15.76 28.6799 14.97 28.2099L13.24 27.2199C12.33 26.6999 12.02 25.5299 12.54 24.6299C13.45 23.0599 12.71 21.7799 10.9 21.7799C9.85 21.7799 9 20.9199 9 19.8799Z",
    stroke: "#32174E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/Setting.6659b4cd3ff661a4129c3739d557bac0.svg";
export { ForwardRef as ReactComponent };